/**
 * Get full URL for your API endpoints.
 * @param path - the path after /api
 */
export function getApiUrl(path: string = ""): string {
  // Base host comes from Vite env
  return `${import.meta.env.VITE_YEATI_API_URL}${path}`;
}

/**
 * Build a URL with pagination and optional query parameters
 * @param baseUrl - The base URL (can include getApiUrl result)
 * @param page - The page number
 * @param queryParams - Optional query parameters (URLSearchParams or object)
 * @param pathSuffix - Optional path suffix to append to baseUrl
 */
export function buildUrlWithPagination(
  baseUrl: string,
  page: number,
  queryParams?: URLSearchParams | Record<string, string | number> | null,
  pathSuffix?: string,
): string {
  const url = pathSuffix ? `${baseUrl}${pathSuffix}` : baseUrl;

  // If no query params, use simple string concatenation for better performance
  if (!queryParams) {
    return `${url}?page=${page}`;
  }

  const params = new URLSearchParams();
  params.append("page", page.toString());

  if (queryParams instanceof URLSearchParams) {
    // If it's already URLSearchParams, iterate over it
    for (const [key, value] of queryParams.entries()) {
      params.append(key, value);
    }
  }
  else {
    // If it's an object, convert it
    Object.entries(queryParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value.toString());
      }
    });
  }

  return `${url}?${params.toString()}`;
}
